<app-flink-branded-modal>
  <app-progress-gauge *ngIf="!profileComplete" class="mx-0 m-sm-auto" [dontShowProfilePicture]="true" [showIncompleteOnly]="true"
                      (profileComplete)="onChangeModalTitle($event)"></app-progress-gauge>
</app-flink-branded-modal>



